<script>
import ratingStarActive from "../../images/rating-star-active.svg"
import ratingStarHalf from "../../images/rating-star-half.svg"
import ratingStar from "../../images/rating-star.svg"

export default {
  props: [
    "rating",
    "reviews_count"
  ],
  data() {
    return {
      ratingStarActive: ratingStarActive,
      ratingStarHalf: ratingStarHalf,
      ratingStar: ratingStar,
      full: 0,
      half: 0,
      empty: 0,
    }
  },
  mounted() {
    this.full = Math.floor(this.rating)
    this.empty = 5 - Math.ceil(this.rating)
    this.half = 5 - this.full - this.empty
  }
}
</script>

<template>
  <div class="d-flex">
    <div v-for="item in full"  class="star">
      <img :src="ratingStarActive" alt="rating star active" />
    </div>
    <div v-for="item in half" class="star">
      <img :src="ratingStarHalf" alt="rating star half" />
    </div>
    <div v-for="item in empty" class="star">
       <img :src="ratingStar" alt="rating star" />
    </div>
    <div class="ms-2 link text-s">
      {{this.reviews_count}}
      <span v-if="reviews_count > 1">
        Reviews
      </span>
      <span v-else>
        Review
      </span>
    </div>
  </div>
</template>